import { useMemo } from 'react';

import IconButton from 'lib/IconButton';
import oocFrameSvg from 'assets/icons/ooc_frame.svg';
import { ButtonSize, Theme } from 'lib/IconButton/IconButton.types';
import Tooltip, { TooltipDirection, TooltipTheme } from 'lib/Tooltip';
import { DealAction } from 'components/common/types/Deal.types';
import { OOCReportButtonProps } from './OOCReportButton.types';

export const OOCReportButton = ({
  oocFramesCount,
  onClick,
  dismountedSearch,
}: OOCReportButtonProps): React.ReactElement => {
  const tooltipContent = useMemo(() => {
    if (dismountedSearch === DealAction.ACTIVE) return 'Clear OOC frames filter';

    return !oocFramesCount ? 'No campaigns with OOC frames' : 'Resolve OOC frames';
  }, [dismountedSearch, oocFramesCount]);

  return (
    <Tooltip direction={TooltipDirection.BOTTOM} theme={TooltipTheme.DARK} tooltip={tooltipContent}>
      <div>
        <IconButton
          className="w-9 h-9 self-center"
          icon={oocFrameSvg}
          name="ooc-report"
          handleOnClick={onClick}
          theme={Theme.TERTIARY}
          buttonSize={ButtonSize.LARGE}
          isDisabled={!oocFramesCount && dismountedSearch !== DealAction.ACTIVE}
          badgeCount={oocFramesCount}
        />
      </div>
    </Tooltip>
  );
};
